import React, {useState} from 'react';
import styled from 'styled-components';
import moment from 'moment';
import numeral from 'numeral';
import {V2_BORDER_COLOR, V2_ACTIVE_COLOR, V2_INACTIVE_TEXT_COLOR, V2_INACTIVE_COLOR, V2_BACKGROUND_COLOR, V2_POINT_COLOR, V2_BLACK_COLOR, BLUE_COLOR, V2_BUTTON_COLOR, V2_INACTIVE_BORDER_COLOR} from '../config/color';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import {Line, Chart} from 'react-chartjs-2';
import useAsync from "../config/useAsync";
import SearchIcon from "../assets/image/Search.png";
import ArrowIcon from "../assets/image/arrow.png";
import EmptyIcon from '../assets/image/specular.png'
import GAEvent from '../utils/googleAnalytics';
import IncludeItemSeller from './Modal/IncludeItemSeller';

import {seller} from '../config/api';



const BlockContainerWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`;

const BlockContainer = styled.div`
  width: 100%;
  /* width: 858px; */
  border-top: 3px solid ${V2_INACTIVE_BORDER_COLOR};
  
`;

const BlockTopArticle = styled.div`
  width: 100%;
  margin-top: 10px;
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
`;

const SearchWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 54px;
  padding-bottom: 30px;
  margin-right: 20px;
  margin-left: 20px;
`

const SearchBox = styled.div`
  padding: 12px 24px;
  border: 1px solid ${V2_BORDER_COLOR};
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const SearchBoxText = styled.input`
  font-size: 16px;
  color: ${V2_BORDER_COLOR};
  margin-right: 20px;
  font-weight: 300;
  border: none;
  background-color: ${V2_BACKGROUND_COLOR};
  &:focus {
    outline: none;
  }
`

const OrderWrap = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
`

const ItemBox = styled.div`
  box-shadow: 0 0.5rem 1.2rem rgba(0, 0, 0, 0.1);
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 24px;
  margin-bottom: 10px;
  /* padding: ${props => (!props.showDetail ? '25px 45px' : '45px' )}; */
  padding: 24px;
`

const ItemBoxLeftWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const  ItemBoxRightWrap = styled.div`
  /* margin-left: 30px;
  padding-left: 30px;
  border-left: 2px solid ${V2_INACTIVE_TEXT_COLOR}; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`

const ItemModelName = styled.span`
  font-weight: 600;
  font-size: 18px;
  color: ${V2_BLACK_COLOR};
`

const Image = styled.img`
  width: 14px;
`;

const PriceList = styled.li`
  font-size: 12px;
  /* line-height: 24px; */
  color: ${V2_INACTIVE_COLOR};
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`

const NormalText = styled.p`
  font-size: 12px;
  color: ${V2_INACTIVE_COLOR};
`

const ComparisonColor = styled.p`
  font-weight: 600;
  /* color: #77838f !important; */
  color: ${props => (props.color > 0 ? `${V2_POINT_COLOR}` : props.color === 0 ? `${V2_BLACK_COLOR}` : `${BLUE_COLOR}`)} ;
  /* margin-left: 10px; */
  display: flex;
  align-items: center;
`;


const ButtonStyleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
`

const ButtonStyle = styled.button`
  border: none;
  background-color: white;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ButtonImage = styled.img`
  width: 15px;
  transform: ${props => (!props.showDetail ? 'rotate(0deg)' : 'rotate(180deg)')};
  transition: 0.2s all;
`

const LinkButtonText = styled.button`
  background-color: ${V2_BUTTON_COLOR};
  border-radius: 16px;
  padding: 16px 24px;
  border: none;
  color: white;
  font-weight: 600;
  font-size: 16px;
  outline: none;
`

const ButtonText = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${V2_ACTIVE_COLOR};
  margin-right: 10px;
`

const PriceListGroup = styled.div`
  display: flex;
  margin-right: 20px;
`

const ItemNameText = styled.p`
  font-weight: 700;
  color: ${V2_INACTIVE_COLOR};
  font-size: 24px;
  line-height: 24px;
  /* margin-bottom: ${props => (!props.showDetail ? '30px' : '30px')}; */
`

const ItemImageContainer = styled.p`
  width: 76px;
`

const HideDetailItemImageContainer = styled.p`
  display: ${props => (!props.showDetail ? 'block' : 'none')};
`

const ShowDetailItemImageContainer = styled.div`
  display: ${props => (!props.showDetail ? 'none' : 'flex')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-right: 20px;
  border-right: 2px solid ${V2_INACTIVE_BORDER_COLOR};
`

const ExtraBoldText = styled.p`
  font-weight: 700;
  color: ${V2_BLACK_COLOR};
  font-size: 12px;
`
const BoldText = styled.p`
  font-weight: 600;
  font-size: 12px;
  color: ${V2_INACTIVE_COLOR};
`

const DetailPriceText = styled.p`
  font-size: 26px;
  font-weight: 600;
  color: ${V2_ACTIVE_COLOR};
`

const DetailPriceTextSmall = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${V2_ACTIVE_COLOR};
  padding-bottom: 2px;
`

export default (props) => {
  const getWatchDataList = props?.getWatchData;
  
  const [showDetail, setShowDetail] = useState(false);
  const [order, setOrder] = useState(0);
  const [keywords, setKeyword] = useState("");
  const [searchList, setSearchList] = useState([]);
  const [checkItem, setCheckItem] = useState(-1);
  const [itemInfo, setItemInfo] = useState(null);
  const [sellerList, setSellerList] = useState(null);
  const [modalIsOpen,setIsOpen] = useState(false);
  const [activeEventKey, setActiveEventKey] = useState(0);
  // const [listItems, setListItems] = useState(searchList.length === 0 ? getWatchDataList : searchList);
  const [noSearchList, setNoSearchList] = useState('찾으시는 물품이 없습니다.');


  const _onShowDetail = (o, i) => {
    GAEvent('Detail', '자세한 정보 보기', o.name);
    if(checkItem === i) {
      setCheckItem(-1);
    } else {
      setCheckItem(i);
    }
  }

  const _onSellerShop = async (o, i) => {
    GAEvent('Button', '판매처 정보 보기', o.name);
    try {
      setIsOpen(true);
      setItemInfo(o);
      const r = await seller.getItemSellerList(o?.itemId);
      r?.data?.data?.map( async (v) => {
        await seller.sellerItemViewCount(v?.sellerId);
      })
      setSellerList(r?.data.data)

      // setSellerList(Object.values(r?.data?.data.reduce((acc,cur) => Object.assign( acc,{ [cur.sellerId]:cur} ),{})));
    } catch(e) {
      console.log(e);
    }
  }

  const _closeSellerInfo = (o) => {
    setIsOpen(false);
  }

  return (
    <BlockContainerWrap>
      <BlockContainer>
        <BlockTopArticle>
          {getWatchDataList.length !== 0 ? getWatchDataList?.map((o, i) => {
            const recentlyHighPrice = numeral(o.highPrice[o.highPrice.length - 1]).format('0,0');
            const recentlyMedianPrice = numeral(o.medianPrice[o.medianPrice.length - 1]).format('0,0');
            const recentlyLowPrice = numeral(o.lowPrice[o.lowPrice.length - 1]).format('0,0');
            const comparPrice = o.medianPrice.length < 2 ? 0 : ( (o.medianPrice[o.medianPrice.length - 1] - o.medianPrice[o.medianPrice.length - 2]));
            const recentlyDate = o.dateTrend[o.dateTrend.length - 1];
            return (
              <ItemBox key={i} id={`${i}_item`} showDetail={checkItem === i}>
                <ItemBoxLeftWrap>
                  <p style={{marginBottom: 15, position: 'relative', top: 0}}>
                    <ItemModelName>{o.name}</ItemModelName>
                  </p>
                  <HideDetailItemImageContainer showDetail={checkItem === i}>
                    <ItemImageContainer>
                      <img style={{width: '100%'}} src={o.image} />
                    </ItemImageContainer>
                    <p style={{marginTop: 15}}>
                      <ItemModelName>{o.category3}</ItemModelName>
                    </p>
                  </HideDetailItemImageContainer>
                </ItemBoxLeftWrap>
                <ItemBoxRightWrap>
                  {checkItem === i && (
                    <div style={{width: '100%', marginTop: 30}}>
                      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                        <ShowDetailItemImageContainer showDetail={checkItem === i}>
                          <ItemImageContainer>
                            <img style={{width: '100%'}} src={o.image} />
                          </ItemImageContainer>
                          <p style={{marginTop: 15}}>
                            <ItemModelName style={{fontSize: 12}}>{o.category3}</ItemModelName>
                          </p>
                        </ShowDetailItemImageContainer>
                        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center'}}>
                          <div>
                            <div style={{display: 'flex', alignItems: 'center', marginBottom: 20}}>
                              <ExtraBoldText>시세</ExtraBoldText>
                              <ExtraBoldText style={{color: `${V2_INACTIVE_COLOR}`}} >&nbsp;&nbsp;|&nbsp;&nbsp;</ExtraBoldText>
                              <BoldText>{recentlyDate} 기준</BoldText>
                            </div>
                            <div style={{display: 'flex', alignItems: 'flex-end', marginBottom: 30}}>
                              <DetailPriceText>{recentlyMedianPrice}</DetailPriceText>
                              <DetailPriceTextSmall>&nbsp;원</DetailPriceTextSmall>
                            </div>
                          </div>
                          <div>
                            <LinkButtonText onClick={() => _onSellerShop(o, i)}>판매처 정보 보기</LinkButtonText>
                          </div>
                        </div>
                      </div>
                      <div>
                        <Line
                          // width={400}
                          // height={200}
                          data={{
                            labels: o.dateTrend,
                            datasets: [
                              {
                                fill: false,
                                lineTension: 0.1,
                                backgroundColor: '#56afe4',
                                borderColor: 'rgba(116, 143, 181, 0.56)',
                                borderCapStyle: 'butt',
                                borderDash: [],
                                borderDashOffset: 0.0,
                                borderJoinStyle: 'miter',
                                pointBorderColor: `white`,
                                pointBackgroundColor: `${V2_ACTIVE_COLOR}`,
                                pointBorderWidth: 2,
                                pointHoverRadius: 4,
                                pointHoverBackgroundColor: `${V2_ACTIVE_COLOR}`,
                                pointHoverBorderColor: 'rgba(220,220,220,1)',
                                pointHoverBorderWidth: 1,
                                pointRadius: 4,
                                pointHitRadius: 10,
                                borderWidth: 2,
                                data: o.medianPrice
                              },
                            ]
                          }}
                          options={
                            {
                              layout: {
                                padding: {
                                  top: 20,
                                }
                              },
                              legend: {
                                display: false
                              },
                              scales: {
                                
                                xAxes: [{
                                  gridLines: {
                                    drawOnChartArea: false
                                  },
                                  ticks:{
                                    callback:function(label){
                                      var year = label.split("-")[0];
                                      var monthDay = label.split("-")[1]+"/"+label.split("-")[2];
                                      return monthDay;
                                    },
                                    maxRotation: 0,
                                    fontColor: `${V2_INACTIVE_COLOR}`,
                                    fontSize: 12,
                                    fontWeight: 300

                                  },
                                }],
                                yAxes: [{
                                  ticks: {
                                    display: false,
                                    // stepSize: 3
                                  },
                                  gridLines: {
                                    // drawOnChartArea: false,
                                    color: "rgba(0, 0, 0, 0)",
                                  }
                                }]
                              }
                            }
                          }
                          />
                        </div>
                      </div>
                    )}
                    <ul style={{width: '100%', marginTop: 20, paddingBottom: 30, borderBottom: `2px solid ${V2_INACTIVE_BORDER_COLOR}`, marginBottom: 20}}>
                      <PriceList style={{alignItems: 'flex-start'}}>
                        <PriceListGroup style={{display: 'flex', flex: 1}}>
                          <p style={{color: `${V2_BLACK_COLOR}`, fontWeight: 600}}>기준가</p>
                          <p>&nbsp;&nbsp;|</p>
                        </PriceListGroup>
                        <div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end'}}>
                          <p style={{fontWeight: 600, color: `${V2_BLACK_COLOR}`, marginBottom: 5}}>{recentlyMedianPrice}원</p>
                          {comparPrice > 0 ? (
                            <ComparisonColor color={comparPrice}>
                              <PlayArrowIcon style={{transform: 'rotate(270deg)', fontSize: 12}} />
                              <p>
                                {numeral(comparPrice).format('0,0')}원
                              </p>
                            </ComparisonColor>
                          ) : comparPrice === 0 ? (
                            <ComparisonColor color={comparPrice}>
                              <p>
                                -
                              </p>
                            </ComparisonColor>
                          ) : (
                            <ComparisonColor color={comparPrice}>
                              <PlayArrowIcon style={{transform: 'rotate(90deg)', fontSize: 12}} />
                              <p>
                                {numeral(comparPrice).format('0,0')}원
                              </p>
                            </ComparisonColor>
                          )}
                        </div>
                        
                      </PriceList>
                      <PriceList>
                        <PriceListGroup>
                          <p>최고 평균 기준가</p>
                          <p>&nbsp;&nbsp;|</p>
                        </PriceListGroup>
                        <p>{recentlyHighPrice}원</p>
                      </PriceList>
                      <PriceList>
                        <PriceListGroup>
                          <p>최저 평균 기준가</p>
                          <p>&nbsp;&nbsp;|</p>
                        </PriceListGroup>
                        <p>{recentlyLowPrice}원</p>
                      </PriceList>
                    </ul>
                </ItemBoxRightWrap>
                <ButtonStyleContainer>
                  <ButtonStyle onClick={() => _onShowDetail(o, i)}> 
                    {checkItem === i ? (
                      <ButtonText>
                        자세한 정보 닫기
                      </ButtonText>
                    ) : (
                      <ButtonText>
                        자세한 정보 보기
                      </ButtonText>
                    )}
                    <ButtonImage showDetail={checkItem === i} src={ArrowIcon} alt="ArrowIcon" />
                  </ButtonStyle>
                </ButtonStyleContainer>
              </ItemBox>
            )
          }) : (
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: 20}}>
              <div style={{marginBottom: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                <p style={{fontWeight: 900, fontSize: 16, lineHeight: '26px'}}>
                  이런!
                </p>
                <p style={{fontWeight: 500, fontSize: 16, lineHeight: '26px'}}>
                  0개의 결과를 찾았습니다.
                </p>
                <p style={{fontWeight: 500, fontSize: 16, lineHeight: '26px'}}>
                  트레져러는 매일 매일 조금씩 자라나고 있습니다.
                </p>
              </div>
              <div>
                <p style={{width: 80, marginBottom: 20}}>
                  <img src={EmptyIcon} style={{width: '100%'}} />
                </p>
                <p style={{fontWeight: 900, fontSize: 12, lineHeight: '20px'}}>
                  (쩜쩜쩜... 죄송해요)
                </p>
              </div>
            </div>
          )}
        </BlockTopArticle>
      </BlockContainer>
      <IncludeItemSeller modalIsOpen={modalIsOpen} modalIsClose={_closeSellerInfo} sellerList={sellerList} />
    </BlockContainerWrap>
  )
}